import cloneDeep from 'lodash/cloneDeep';
import worldData from './world';
import usData from './us';
import widgetHelper from '../../widget-utilities/widget-helper';
import d3Utils from '../../../../utils/d3Utils';
import chartUtils from '../../../../utils/chart-utils';

/* Config builder for world map */
var worldMapConfigBuilder = function worldMapConfigBuilder() {

    // Intialize Object.prototype.hasOwnProperty with global variable
    var hasProperty = Object.prototype.hasOwnProperty;

    // Modify HeatMapSeriesData to the config
    var modifyHeatMapSeriesData = function modifyHeatMapSeriesData(heatMapSeriesData) {
        if (heatMapSeriesData != null && heatMapSeriesData.toString().trim().length > 0) {
            heatMapSeriesData = chartUtils.tryJsonParse(heatMapSeriesData);
        }
        return heatMapSeriesData;
    };

    // Add modified HeatMapData to the Config
    var addHeatMapData = function addHeatMapData(data, mapConfig) {
        if (!(mapConfig.HeatMapSeries === null || mapConfig.HeatMapSeries === '') && hasProperty.call(data, 'heatmapData')) {
            if (hasProperty.call(data, 'heatmapZoneClassifiers')) {
                mapConfig.HeatMapZoneClassifiers = data['heatmapZoneClassifiers'];
            } else {
                mapConfig.HeatMapZoneClassifiers = null;
            }
            mapConfig.HeatMapSeriesData = data['heatmapData'];
        } else {
            mapConfig.HeatMapSeries = null;
            mapConfig.HeatMapSeriesData = null;
            mapConfig.HeatMapZoneClassifiers = null;
        }
    };

    // Add modified MarkerSeriesData to the config
    var modifyMarkerSeriesData = function modifyMarkerSeriesData(markerSeriesData) {
        if (markerSeriesData != null && markerSeriesData.toString().trim().length > 0) {
            markerSeriesData = chartUtils.tryJsonParse(markerSeriesData);
        }
        return markerSeriesData;
    };

    // Add modified MarkerSeries to the config
    var addMarkerData = function addMarkerData(data, mapConfig) {
        if (!(mapConfig.MarkerSeries === null || mapConfig.MarkerSeries === '') && hasProperty.call(data, 'markerData')) {
            mapConfig.MarkerSeriesData = data['markerData'];
        } else {
            mapConfig.MarkerSeries = null;
            mapConfig.MarkerSeriesData = null;
        }
    };

    // Push modifed MarkerSeries to the config
    var modifyMarkerSeries = function modifyMarkerSeries(mapConfig) {
        var mapMarkerSeriesConfig = {
            SeriesName: null,
            MarkerField: null,
            MarkerLabelField: null,
            LatitudeField: null,
            LongitudeField: null,
            DataUrl: null,
            DataPropertyName: 'Data',
            CrumbMetaName: null,
            CrumbFieldName: null,
            CrumbDisplayFieldName: null,
            MarkerCrumbMetaName: null,
            MarkerCrumbFieldName: null,
            MarkerType: 'c',
            MarkerIcon: null,
            MarkerClassifierFieldName: null,
            Color: null,
            ScaleCoefficient: 0.0,
            MarkerScaleFieldName: null,
            Source: null,
            Context: null,
            CompoundTipField: null,
            TotalRecords: true,
            DefaultPerspective: null
        };
        if (!(mapConfig.DataUrl === null || mapConfig.DataUrl === '') && !(mapConfig.MarkerField === null || mapConfig.MarkerField === '') && !(mapConfig.LatitudeField === null || mapConfig.LatitudeField === '') && !(mapConfig.LongitudeField === null || mapConfig.LongitudeField === '')) {
            var series = mapMarkerSeriesConfig;
            series.SeriesName = mapConfig.MarkerField;
            series.MarkerField = mapConfig.MarkerField;
            series.MarkerLabelField = mapConfig.MarkerLabelField;
            series.LatitudeField = mapConfig.LatitudeField;
            series.LongitudeField = mapConfig.LongitudeField;
            series.DataUrl = mapConfig.DataUrl;
            series.DataPropertyName = mapConfig.DataPropertyName;
            series.CrumbMetaName = mapConfig.CrumbMetaName;
            series.CrumbFieldName = mapConfig.CrumbFieldName;
            series.CrumbDisplayFieldName = mapConfig.CrumbDisplayFieldName;

            if (mapConfig.MarkerSeries === null) {
                series = mapMarkerSeriesConfig;
            }
            mapConfig.MarkerSeries.push(series);
        }
    };

    // Add modified MergeData to the config
    var addMergeData = function addMergeData(data, mapConfig) {
        if (hasProperty.call(data, 'mergeData')) {
            mapConfig.MergeData = data['mergeData'];
        } else {
            mapConfig.MergeData = null;
        }
        return mapConfig.MergeData;
    };

    // Add modified ConnectionSeriesData to the config
    var modifyConnectionSeriesData = function modifyConnectionSeriesData(connectionSeriesData) {
        if (connectionSeriesData != null && connectionSeriesData.toString().trim().length > 0) {
            connectionSeriesData = chartUtils.tryJsonParse(connectionSeriesData);
        }
        return connectionSeriesData;
    };

    // Add modified ConnectionSeries to the config
    var addConnectionSeries = function addConnectionSeries(data, mapConfig) {
        if (hasProperty.call(data, 'connectionsData') && !(mapConfig.MapConnectionSeries === null || mapConfig.MapConnectionSeries === '')) {
            mapConfig.ConnectionSeries = mapConfig.MapConnectionSeries;
            mapConfig.ConnectionSeriesData = data['connectionsData'];
        } else {
            mapConfig.ConnectionSeries = null;
            mapConfig.ConnectionSeriesData = null;
        }
    };

    // Add modifed MergePropertyName to the config
    var modifyMergeMatchPropertyName = function modifyMergeMatchPropertyName(mergeMatchPropertyName) {
        if (mergeMatchPropertyName === null) {
            return '';
        } else {
            return mergeMatchPropertyName;
        }
    };

    // Add modified CenterCoordinates to the config
    var modifyCenterCoordinates = function modifyCenterCoordinates(centerCoordinates) {
        if (centerCoordinates != null && centerCoordinates.length === 2) {
            return JSON.stringify(centerCoordinates);
        } else {
            return null;
        }
    };

    // Add modifed MarkerPieFieldNames to the config
    var modifyPieFieldNames = function modifyPieFieldNames(markerPieFieldNames) {
        if (markerPieFieldNames != null && markerPieFieldNames.length > 0) {
            markerPieFieldNames = JSON.stringify(markerPieFieldNames);
        } else {
            return null;
        }
        if (markerPieFieldNames != null && markerPieFieldNames.toString().trim().length > 0) {
            markerPieFieldNames = chartUtils.tryJsonParse(markerPieFieldNames);
        }
        return markerPieFieldNames;
    };

    // Add modified MarkerType to the config
    var modifyMarkerType = function modifyMarkerType(markerType) {
        var markers = {
            d: 'diamond',
            tu: 'triangle-up',
            td: 'triangle-down',
            s: 'square',
            Pie: 'pie',
            c: 'circle'
        };
        return markers[markerType] ? markers[markerType] : markers['c'];
    };

    // Add modifed MapData to the config
    var addMapData = function addMapData(mapType) {
        var mapData = void 0;
        switch (mapType) {
            case 'USStates':
            case 'USCounties':
                mapData = usData;
                break;
            case 'World':
            default:
                mapData = worldData;
                break;
        }
        return mapData;
    };

    // Add custom properties to original config
    var modifyMapConfigProperties = function modifyMapConfigProperties(config) {
        var _config$MapConfig = config.MapConfig,
            MarkerClassifierFieldName = _config$MapConfig.MarkerClassifierFieldName,
            MarkerScaleFieldName = _config$MapConfig.MarkerScaleFieldName,
            MarkerValueFieldName = _config$MapConfig.MarkerValueFieldName,
            TipField = _config$MapConfig.TipField,
            BaseFormat = _config$MapConfig.BaseFormat,
            MapClassifierName = _config$MapConfig.MapClassifierName,
            MapType = _config$MapConfig.MapType,
            MarkerType = _config$MapConfig.MarkerType,
            MarkerIcon = _config$MapConfig.MarkerIcon,
            MarkerPieFieldNames = _config$MapConfig.MarkerPieFieldNames,
            CenterCoordinates = _config$MapConfig.CenterCoordinates,
            MergeMatchPropertyName = _config$MapConfig.MergeMatchPropertyName,
            Data = config.Data;

        // Initialize properties with empty strings if properties are null

        config.MapConfig.MarkerClassifierFieldName = widgetHelper.initializeConfigPropertyWithEmptyString(MarkerClassifierFieldName);
        config.MapConfig.MarkerScaleFieldName = widgetHelper.initializeConfigPropertyWithEmptyString(MarkerScaleFieldName);
        config.MapConfig.MarkerValueFieldName = widgetHelper.initializeConfigPropertyWithEmptyString(MarkerValueFieldName);
        config.MapConfig.TipField = widgetHelper.initializeConfigPropertyWithEmptyString(TipField);
        config.MapConfig.BaseFormat = widgetHelper.initializeConfigPropertyWithEmptyString(BaseFormat);
        config.MapConfig.MapClassifierName = widgetHelper.initializeConfigPropertyWithEmptyString(MapClassifierName);

        config.MapConfig.MapData = addMapData(MapType);
        config.MapConfig.MarkerType = modifyMarkerType(MarkerType);
        config.MapConfig.MarkerPieFieldNames = modifyPieFieldNames(MarkerPieFieldNames);
        config.MapConfig.CenterCoordinates = modifyCenterCoordinates(CenterCoordinates);
        config.MapConfig.MergeMatchPropertyName = modifyMergeMatchPropertyName(MergeMatchPropertyName);

        // Modify Connections data according to the configuration selected
        // Using the updated MapConfig as a parameter in this function
        addConnectionSeries(Data, config.MapConfig);
        config.MapConfig.ConnectionSeriesData = modifyConnectionSeriesData(config.MapConfig.ConnectionSeriesData);

        // Add Merge data according to the configuration selected
        // Using the updated MapConfig as a parameter in this function
        config.MapConfig.MergeData = addMergeData(Data, config.MapConfig);

        // Modify Marker data and to the MapConfig according to the configuration selected
        // Using the updated MapConfig as a parameter in this function
        modifyMarkerSeries(config.MapConfig);
        addMarkerData(Data, config.MapConfig);
        config.MapConfig.MarkerSeriesData = modifyMarkerSeriesData(config.MapConfig.MarkerSeriesData);

        // Modify Heatmap data and to the MapConfig according to the configuration selected
        // Using the updated MapConfig as a parameter in this function
        addHeatMapData(Data, config.MapConfig);
        config.MapConfig.HeatMapSeriesData = modifyHeatMapSeriesData(config.MapConfig.HeatMapSeriesData);

        return config;
    };

    var configBuilder = function configBuilder(config) {
        // Add common widget config properties
        config = widgetHelper.modifyWidgetConfigProperties(cloneDeep(config));

        // Modify map specific config properties
        config = modifyMapConfigProperties(cloneDeep(config));

        return config;
    };

    return {
        configBuilder: configBuilder
    };
};
export default worldMapConfigBuilder();